<script>
  import {ignore, makeWebsiteRequest} from '../../../Common/tools';
  import {External, M} from '../../../external';
  import {onMount} from 'svelte';

  export let data = {};
  export let onChange = ignore;

  if (!data.settings) {
    data.settings = [];
  }

  let settings = data.settings[0] ? JSON.parse(data.settings[0].value) :
    {
      automationId: '0'
    }

  let automations;

  $: if (automations?.length && settings?.automationId !== '0') {
    data.settings[0] = {
      key: '0',
      value: JSON.stringify({
        automationId: settings.automationId
      })
    };

    onChange();
  }

  onMount(async () => {
    let resp = await makeWebsiteRequest({action: 'getAutomationNames'}).catch(() => {
      External.Tools.showError(M.NO_AUTOMATIONS_YET);
    });

    automations = resp.data || null;
  });

</script>

<div class='col20 f-left small-rules mb-25'>
  <h4 class='col20 f-left mt-15 mb-10 t-center' style='line-height:1.4;'>{M.WHEN_AUTOMATION_GOAL_IS_REACHED}</h4>
  <div class='popup-input-wrapper f-left mt-25'>
    <div class='info'>
      <h5>{M.SELECT_AN_AUTOMATION}</h5>
    </div>
    {#if automations}
      <select class='page-select' bind:value={settings.automationId}>
        <option value='0' disabled>{M.PLEASE_SELECT}</option>
        {#each automations as auto}
          <option value='{auto.id}'>{auto.name}</option>
        {/each}
      </select>
      {/if}
  </div>
</div>
